import * as React from 'react';
import styled from 'styled-components'
import {ConstBreakPoint, ConstColor, ConstWidth} from "../../../../config/styles_const/styles_const";

interface IProps {
}

const UnknownUserMenu: React.FC<IProps> = (props) => {

    return (
        <Wrapper/>
    );
};

export default UnknownUserMenu;

const Wrapper = styled.div`
    display: block;
    width: ${ConstWidth.MenuWidth};
    height: 100%;
    background-color: ${ConstColor.DeepBlack};
    @media screen and (min-width: ${ConstBreakPoint.Default}) {
        display: none;
    }
`;


// WEBPACK FOOTER //
// ./src/presentation/common/organism/menu/unknown_user_menu.tsx